/**
 * Image Attachment Component
 * Displays image attachments with lightbox support
 */

import { useState } from 'react';
import type { MessageAttachment } from '@/types/api.types';
import { getAttachmentUrl } from '@/services/attachments.service';

interface ImageAttachmentProps {
  attachment: MessageAttachment;
  onLightboxOpen: (attachmentId: string) => void;
}

const ImageAttachment = ({
  attachment,
  onLightboxOpen,
}: ImageAttachmentProps) => {
  const [imageError, setImageError] = useState(false);
  const imageUrl = getAttachmentUrl(attachment.id);

  if (imageError) {
    return (
      <div className="flex items-center space-x-2 p-3 bg-gray-50 rounded-lg max-w-sm">
        <span className="text-2xl">🖼️</span>
        <div>
          <p className="text-sm font-medium text-gray-900">
            {attachment.file_name}
          </p>
          <p className="text-xs text-red-600">
            Грешка при зареждане на изображението
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="group relative max-w-sm">
      <img
        src={imageUrl}
        alt={attachment.file_name}
        className="rounded-lg cursor-pointer hover:opacity-90 transition-opacity max-h-96 object-cover"
        onClick={() => onLightboxOpen(attachment.id)}
        onError={() => setImageError(true)}
        loading="lazy"
      />

      {/* Hover overlay with filename */}
      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all rounded-lg flex items-end p-2 pointer-events-none">
        <p className="text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity truncate">
          {attachment.file_name}
        </p>
      </div>
    </div>
  );
};

export default ImageAttachment;
